import React from 'react';
import { Footer, Header, initRuntime } from '@tencent/dz-runtime';
import { REPORT_EVENT_KEY } from '@tencent/dz-report';
import { Components } from '@tencent/dz-elements-web';
import { Bricks } from '@tencent/dz-bricks-web';
import { ImpCoreModel } from 'src/models';
import { report as reportInstance } from 'src/helper';
import { useTcaptcha } from 'src/hooks';
// import { windowMock } from 'src/mock';
import '@tencent/xj-components-h5/css/reset.css';

// (window as any).FMC_HOST = windowMock;

const model = new ImpCoreModel();

const Runtime = initRuntime(Components, Bricks as any);

export const App = () => {
  const isLimited = useTcaptcha(model);

  React.useEffect(() => {
    model.mounted();
  }, []);

  const events = React.useMemo(() => {
    return {
      [REPORT_EVENT_KEY]: reportInstance,
    };
  }, []);

  if (isLimited) {
    return null;
  }

  const FooterContainer = () => {
    // ai历史消息流量不展示footer， 因为入口进来就初始化，所以不需要使用useHook来监听
    if (model.getConsultModel().isAIStaffPreviewTraffic()) return null;
    return (
      <Footer>
        <Bricks.BlockInputting />
        <Bricks.BlockConsultMenu />
        <Bricks.BlockBottomSend />
      </Footer>
    );
  };


  return (
    <Runtime model={model} events={events}>
      <Header>
        <Bricks.TopHospital />
        <Bricks.TopCard />
      </Header>
      <Bricks.DetainmentModal />
      <FooterContainer />
    </Runtime>
  );
};
